import { css } from '@mui/material/styles';
export const formHelperTextComponentOverrides = {
    MuiFormHelperText: {
        styleOverrides: {
            root: ({ theme }) => css `
                margin: 3px 0 0;
                color: ${theme.tokens.FuelColorTextTertiary};

                &.Mui-disabled {
                    color: ${theme.tokens.FuelColorTextTertiary};
                    opacity: 0.4;
                }

                &.Mui-error {
                    color: ${theme.tokens.FuelColorAlertErrorIcon};
                }
            `
        }
    }
};
